<template>
  <div class="themeItem_mode_11" v-if="list">
    <template v-if="modeType">
      <EVENTCOP_MODE_11
        :themeClass="'onlyDisplay'"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="list"
        :competitorType="'D'"
        :modeType="modeType"
      />
    </template>
  </div>
</template>

<script>
//  汤尤杯【本场数据中单场比赛的表格展示】 播出单的主题；运动员名字拼接因此选择 competitorType = D
import cup_base_data_mixin from '@mixins/cup_base_data'
import EVENTCOP_MODE_11 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_11.vue'
export default {
  name: 'themeItem_mode_11',
  mixins: [cup_base_data_mixin],
  components: {
    EVENTCOP_MODE_11,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      list: null,
    }
  },
  watch: {
    datas(newVal, oldVal) {
      if (
        newVal &&
        JSON.stringify(newVal.data.dataList) !==
          JSON.stringify(oldVal.data.dataList)
      ) {
        this.list = this.computedMatchList(newVal)
      }
    },
    immediate: false,
    deep: true,
  },
  created() {
    this.list = this.computedMatchList(this.datas)
  },
  methods: {
    computedMatchList(datas) {
      console.debug('themeItem_mode_11:', this.datas)
      const modeTypeKeyArr = ['single', 'double']
      let eventCompModeDatas = {
        subList: [],
        table_head: [],
      }
      this.modeType = modeTypeKeyArr[datas.objectInfo.length - 1]
      if (datas.data.dataList && datas.data.dataList.length > 0) {
        const subList = []
        const keyArr = ['home', 'away']
        const matchNum = datas.data.dataList[0].length
        const teamDataArr = datas.data.dataList.map((team, teamIndex) => {
          return team.map((item) => {
            return {
              key: keyArr[teamIndex],
              players: item.players.map((player) => {
                return {
                  team_name: item.teamName,
                  team_id: item.teamId,
                  team_logo: item.teamLogo,
                  player_id: player.athleteId,
                  player_name: player.athleteName,
                  player_logo: player.athletePicture,
                  player_gender: player.athleteGender,
                }
              }),
              unit_type: item.matchType,
              unit_type_name: item.matchTypeName,
            }
          })
        })
        console.debug('teamDataArr:', teamDataArr, this.modeType)
        for (let i = 0; i < matchNum; i++) {
          let subItem
          let home_matchItem = teamDataArr[0][i]
          console.debug('home_matchItem:', home_matchItem)
          subItem = {
            home: home_matchItem.players,
            unit_type: home_matchItem.unit_type,
            unit_type_name: home_matchItem.unit_type_name,
          }
          if (this.modeType === 'double') {
            let away_matchItem = teamDataArr[1][i]
            subItem.away = away_matchItem.players
          }
          subList.push(subItem)
        }
        console.debug('subList:', subList)
        eventCompModeDatas = {
          //   subList: [
          //     {
          //       home: [
          //         {
          //           competitor_id: 10495,
          //           team_name: '印度尼西亚',
          //           team_id: 1016,
          //           team_logo:
          //             'https://hyper-sports-res.mixtmt.com/badminton/season/5032022/team/1016.png',
          //           player_id: 10630,
          //           player_name: '金廷',
          //           player_logo: null,
          //           player_gender: 'M',
          //         },
          //       ],
          //       unit_type: 'MS',
          //       unit_type_name: '单打',
          //       unit_code: 'M1',
          //     },
          //     {
          //       home: [
          //         {
          //           competitor_id: 10309,
          //           team_name: '印度尼西亚',
          //           team_id: 1016,
          //           team_logo:
          //             'https://hyper-sports-res.mixtmt.com/badminton/season/5032022/team/1016.png',
          //           player_id: 10783,
          //           player_name: '阿尔菲安',
          //           player_logo: null,
          //           player_gender: 'M',
          //         },
          //         {
          //           competitor_id: 10309,
          //           team_name: '印度尼西亚',
          //           team_id: 1016,
          //           team_logo:
          //             'https://hyper-sports-res.mixtmt.com/badminton/season/5032022/team/1016.png',
          //           player_id: 10784,
          //           player_name: '阿迪安托',
          //           player_logo: null,
          //           player_gender: 'M',
          //         },
          //       ],
          //       unit_type: 'MD',
          //       unit_type_name: '双打',
          //       unit_code: 'M2',
          //     },
          //     {
          //       home: [
          //         {
          //           competitor_id: 10496,
          //           team_name: '印度尼西亚',
          //           team_id: 1016,
          //           team_logo:
          //             'https://hyper-sports-res.mixtmt.com/badminton/season/5032022/team/1016.png',
          //           player_id: 10632,
          //           player_name: '乔纳坦',
          //           player_logo: null,
          //           player_gender: 'M',
          //         },
          //       ],
          //       unit_type: 'MS',
          //       unit_type_name: '单打',
          //       unit_code: 'M3',
          //     },
          //   ],
          subList,
          table_head: [], //不是表格，所以无用，固定返回[]
        }
      }

      console.debug('computedMatchList:', eventCompModeDatas)
      return eventCompModeDatas
    },
  },
}
</script>

<style lang="scss" scoped>
.themeItem_mode_11 {
  width: 100%;
}
</style>
